<script setup lang="ts">
  import { message } from "ant-design-vue";
  import moment from "moment";
  import { onMounted } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { CURRENT_CORP_ID } from "~/enum/cache/cookie";
  import { ACCESS_TOKEN } from "~/enum/cache/cookie";
  import { DATA_URL } from "~/env";
  // import { useStore } from "~/stores/store";
  import Cookie from "~/utils/cookie";
  import DeviceUtils from "~/utils/device-utils";
  import Logger from "~/utils/logger";
  import Storage from "~/utils/storage";

  const router = useRouter();
  const route = useRoute();
  // const store = useStore();
  const $api = useApi();
  useHead({
    titleTemplate: "青律崛起・得理筑梦",
  });
  definePageMeta({
    layout: false,
    middleware: async (to: any) => {
      if (DeviceUtils.isMobile()) {
        const { channel, token } = to.query;
        const queryParams: any = {};

        if (channel) queryParams.channel = channel;
        if (token) queryParams.token = token;

        return navigateTo({
          path: `/h5/activities/qinglvSettled`,
          query: Object.keys(queryParams).length ? queryParams : undefined,
        });
      }
    },
  });
  //立即入驻
  const toJoin = () => {
    router.push("/activities/qinglvSettled/form");
  };

  const shareUrl = ref("");
  const getLastLoginCorpId = async () => {
    const corpId = await $api.getLastLoginCorpId();
    Cookie.set(CURRENT_CORP_ID, corpId);
  };
  const getShareUrl = async () => {
    const url = await $api.getQLShareUrl({ shareType: "invite_lawyer_share_register" });
    shareUrl.value = url;
  };

  const copyText = computed(() => {
    return `“青律崛起・得理筑梦”—— 全国青年律师AI行动公益计划正在招募！法律AI全能工具包、智能名片引流、AI精准案源，8大专属权益一站式配齐，帮你打破技术壁垒、拓宽业务渠道、塑造专业形象！点击以下链接入驻，开启AI赋能的成长新路径：${shareUrl.value}`;
  });

  const onCopy = (text: string) => {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text).then(() => true);
    }

    // 降级方案
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      return successful;
    } catch {
      document.body.removeChild(textArea);
      return false;
    }
  };

  //立即邀请
  const toInvite = async () => {
    if (!shareUrl.value) {
      await $api.auth();
      await getLastLoginCorpId();
      await getShareUrl();
    }

    onCopy(copyText.value);
    message.success("邀请链接已复制，快去分享给你的律师朋友吧！");
  };

  const openRecord = ref(false);
  const getRecordList = async () => {
    $api.queryInviteRecordList({ pageNo: 1, pageSize: 100 }).then((res: any) => {
      recordList.value = res?.data || [];
    });
  };
  const recordList = ref<any[]>([]);

  //格式化时间戳
  const formatTime = (time: number | string | Date = 0, type = "YYYY-MM-DD HH:mm:ss") => {
    return moment(time).format(type);
  };

  //邀请与获奖记录
  const showRecords = async () => {
    await $api.auth();
    openRecord.value = true;
    await getLastLoginCorpId();
    getRecordList();
  };

  //体验法搜
  const toData = () => {
    const win = window.open();
    const url = `${DATA_URL}/`;
    win?.location.replace(url);
  };

  let scaleV = 1;
  const setScale = function () {
    const bd: any = document.querySelector("body");
    const size = 1920;
    const screenW = window.innerWidth;
    const s = size - screenW;
    scaleV = 1 - s / size;
    bd.style.zoom = scaleV;
  };

  onMounted(async () => {
    Logger.event("web_青年律师活动_访问首页");
    if (process.client) {
      setScale();
      window.onresize = setScale;
    }

    // const status = store.temp.getState("status");
    // if (status === "success") {
    //   showPassModal.value = true;
    // }
    const { channel, token } = route.query;
    if (token) {
      const accessToken = Cookie.get(ACCESS_TOKEN);
      accessToken && Cookie.remove(ACCESS_TOKEN);
      Cookie.set(ACCESS_TOKEN, token, 7);
    }

    if (channel) {
      Storage.set("channel", channel);
    }
  });
</script>

<template>
  <div class="wrap">
    <!-- 立即入驻 -->
    <div class="tw-absolute tw-top-[1385px] tw-flex tw-h-[46px] tw-w-full tw-justify-center">
      <div
        @click="toJoin"
        class="tw-h-full tw-cursor-pointer tw-rounded-[36px] tw-opacity-[0.4]"
        style="width: 180px"></div>
    </div>
    <!-- 立即入驻 -->
    <div class="tw-absolute tw-top-[4095px] tw-flex tw-h-[72px] tw-w-full tw-justify-center">
      <div @click="toJoin" class="tw-h-full tw-cursor-pointer tw-rounded-[36px]" style="width: 360px"></div>
    </div>
    <!-- 立即邀请 -->
    <div class="tw-absolute tw-top-[4558px] tw-flex tw-h-[48px] tw-w-full tw-justify-center" style="gap: 96px">
      <div @click="toInvite" style="width: 172px" class="tw-h-full tw-cursor-pointer tw-rounded-[24px]"></div>
      <div @click="showRecords" style="width: 172px" class="tw-h-full tw-cursor-pointer tw-rounded-[24px]"></div>
    </div>

    <div class="tw-absolute tw-right-0 tw-top-[5473px] tw-w-[50%]">
      <div
        @click="toData"
        class="tw-h-[40px] tw-cursor-pointer tw-rounded-[24px] tw-opacity-[0.3]"
        style="width: 173px; margin-left: 135px"></div>
    </div>

    <!-- 邀请与获奖记录 -->
    <a-modal wrap-class-name="record-modal" v-model:open="openRecord" :footer="null">
      <div class="tw-w-[872px]">
        <div class="tw-text-center"> 成功邀请入驻与获奖记录 </div>
        <div
          class="list tw-mt-[30px] tw-w-[872px] tw-rounded-[32px] tw-bg-white tw-text-center tw-border-all-[2px_solid_#EBEEFF]">
          <div
            class="tw-grid tw-h-[72px] tw-w-full tw-grid-cols-4 tw-rounded-t-[32px] tw-bg-[#EDEDFF] tw-px-[36px] tw-text-[18px]
              tw-leading-[72px] tw-text-[#232376]">
            <div>入驻时间</div>
            <div>被邀请人</div>
            <div class="tw-col-span-2">我的邀请奖励</div>
          </div>
          <div
            v-if="recordList.length"
            class="scroll-wrapper tw-max-h-[424px] tw-min-h-0 tw-divide-x-0 tw-divide-y-[1px] tw-divide-solid tw-divide-[#EDEDFF]
              tw-overflow-y-auto tw-px-[36px] tw-leading-[72px]">
            <div class="tw-grid tw-min-h-[72px] tw-w-full tw-grid-cols-4" v-for="(item, i) in recordList" :key="i">
              <div class="tw-flex tw-h-full tw-flex-center">{{ formatTime(item?.inviteTime) }}</div>
              <div class="tw-flex tw-h-full tw-gap-[23px] tw-flex-center">
                <span>{{ item?.name }}</span>
                <span>{{ item?.phone }}</span>
              </div>
              <div class="tw-col-span-2 tw-flex tw-h-full tw-gap-[16px] tw-flex-center">
                <span>{{ item?.desc }}</span>
                <span class="tw-text-[#43AD5E]">（已自动发放）</span>
              </div>
            </div>
          </div>
          <div v-else class="tw-h-[424px] tw-w-[872px] tw-text-[#888] tw-flex-center">暂无记录</div>
        </div>

        <div class="tw-mt-[18px] tw-px-[36px] tw-text-[14px] tw-leading-[20px] tw-text-[#696969]">
          <div class="">
            *邀请奖励规则：每成功邀请1名青年律师入驻，邀请双方可解锁「得理法搜」30天SVIP会员福利。多邀多得，邀请人累计最高可享
            1年会员权益。
          </div>
          <div class="tw-mt-[12px]"> *成功邀请规则：被邀请人通过您分享的专属邀请入驻链接，完成律师认证。 </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
  .wrap {
    position: relative;
    width: 100%;
    min-width: 1200px;
    height: 6480px;
    min-height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    background: url("@/assets/images/activities/wrap-ql.png");
    background-repeat: no-repeat;
    background-size: 100% 6480px;

    :deep(.ant-modal-content) {
      background: #fef8e8;
    }
  }

  .scroll-wrapper {
    width: 100%;
    overflow: hidden auto;
    scrollbar-color: auto;
    scrollbar-width: auto;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #a2accc;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-button {
      display: none;
    }
  }
</style>

<style lang="less">
  .record-modal,
  .pass-modal {
    --ant-modal-content-close-right: -56px;
    --ant-modal-content-close-top: 0;

    .ant-modal {
      width: fit-content !important;
      max-width: auto !important;
    }

    .ant-modal-close {
      top: var(--ant-modal-content-close-top);
      right: var(--ant-modal-content-close-right);
      width: 40px;
      height: 40px;
      color: #70340f; // 关闭按钮颜色

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 40px;
        color: #fff;
        background: rgba(70, 70, 70, 64%);
        border: 1px solid #b4b4b4;
        border-radius: 16px;

        .anticon {
          font-size: 20px;
        }
      }
    }
  }

  .record-modal {
    .ant-modal-content {
      background: #f9f9ff;
      border-radius: 48px;
    }
  }

  .pass-modal {
    .ant-modal {
      width: 628px;
    }

    .ant-modal-content {
      background: linear-gradient(135deg, #3e63ec 0%, #4d79fc 38%, #3cafbe 100%);
      border-radius: 18px;
    }
  }
</style>
